import { createRedux } from '@codeleap/common'
import { appStatusSlice } from './AppStatus'
import { TypedUseSelectorHook, useSelector } from 'react-redux'
import { pulseSlice } from './Pulse'
import { sessionSlice } from './Session'

const middlewares = []

// if (__DEV__) {
//   // eslint-disable-next-line @typescript-eslint/no-var-requires
//   const reduxDebugger = require('redux-flipper').default
//   middlewares.push(reduxDebugger({}))
// }

export const {
  store,
  actions: { AppStatus, Pulse, Session},
} = createRedux({
  AppStatus: appStatusSlice,
  Pulse: pulseSlice,
  Session: sessionSlice,
}, {})

export type RootState = ReturnType<typeof store.getState>
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export * from './AppStatus'
export * from './Pulse'
export * from './Stories'
export * from './Session'
